import { forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { SvgIcon } from '@material-ui/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import type { SvgIconProps, Theme } from '@material-ui/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

import {
  CIRCLE_RADIUS,
  ICON_PADDING,
  ICON_VIEWBOX,
  STROKE_WIDTH,
  getColorsClasses,
} from './constants';
import { Color } from './types';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: ICON_PADDING,
    },
    '@keyframes spin': {
      from: {
        transform: 'rotate(0deg)',
      },
      to: {
        transform: 'rotate(360deg)',
      },
    },
    spinningPath: {
      animation: '$spin 3s linear infinite',
      transformOrigin: 'center',
    },
    ...getColorsClasses(theme),
  });

type TransitionProps = Omit<SvgIconProps, 'classes' | 'children' | 'color'> &
  WithStyles<typeof styles> & {
    color?: Color;
  };

const TransitionIcon = forwardRef<SVGSVGElement, TransitionProps>(
  (props, ref) => {
    const {
      classes,
      className,
      color: colorProp = 'secondary',
      ...otherProps
    } = props;

    const pathD = `M 12 2 A ${CIRCLE_RADIUS} ${CIRCLE_RADIUS} 0 1 1 12 22 A ${CIRCLE_RADIUS} ${CIRCLE_RADIUS} 0 1 1 12 2`;

    return (
      <SvgIcon
        ref={ref}
        viewBox={ICON_VIEWBOX}
        className={classNames(
          classes.root,
          classes[`${colorProp}Color`],
          className,
        )}
        {...otherProps}
      >
        <path
          d={pathD}
          fill="none"
          stroke="currentColor"
          strokeWidth={STROKE_WIDTH}
          strokeDasharray="4 4"
          className={classes.spinningPath}
        />
        <circle
          cx="12"
          cy="12"
          r="3"
          fill="currentColor"
          strokeWidth={STROKE_WIDTH * 2}
        />
      </SvgIcon>
    );
  },
);

TransitionIcon.displayName = 'StateIcon.TransitionIcon';

export default withStyles(styles)(TransitionIcon);
